import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/app/admin/organizations/$organizationId")({
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
